import { Flex, Text } from '@chakra-ui/react';

const EightByEightLicenceTreeHeader = ({
    headerBg,
    borderColor,
    textColor,
    hasVolume = false,
    hasActive = false,
}) => (
    <Flex
        px={4}
        py={2}
        bg={headerBg}
        borderWidth="1px"
        borderColor={borderColor}
        borderBottomWidth={0}>
        <Text
            fontSize="xs"
            fontWeight="600"
            color={textColor}
            flex="1"
            textTransform="capitalize">
            Licence
        </Text>
        <Text
            fontSize="xs"
            fontWeight="600"
            color={textColor}
            textTransform="capitalize"
            w="160px"
            mr={hasVolume || hasActive ? 3 : 0}
            textAlign="center">
            Status
        </Text>
        {hasVolume && (
            <Text
                fontSize="xs"
                fontWeight="600"
                color={textColor}
                textTransform="capitalize"
                w="120px"
                mr={hasActive ? 3 : 0}
                textAlign="center">
                Volume
            </Text>
        )}
        {hasActive && (
            <Text
                fontSize="xs"
                fontWeight="600"
                color={textColor}
                textTransform="capitalize"
                w="120px"
                textAlign="center">
                Active
            </Text>
        )}
    </Flex>
);

export default EightByEightLicenceTreeHeader;
